import { IAdresse } from './address.model';
import { Page } from './page.model';
import { RegistrationStatus } from './registration.model';

export enum UnternehmenRelationship {
  OWNER = 'OWNER',
  INVOICE_RECIPIENT = 'INVOICE_RECIPIENT',
}

export type KundenberaterUnternehmenSearchDto = {
  id: string;
  firstName: string;
  lastName: string;
};

export interface IUnternehmen {
  name: string;
  gpNr: string;
  email: string;
  uid: string;
  adminUserKeycloakId: string;
  hausverwaltung: boolean;
  mitarbeiterAnzahl: string;
  branche: string;
  adresse: IAdresse;
  status: RegistrationStatus;
  accountId?: string;
  adminUserEmail?: string;
  lastInvitation?: string;
  kundenberater?: KundenberaterUnternehmenSearchDto;
}

export type IUnternehmenResponse = Page<IUnternehmen>;
